import React from 'react';
import { Switch, Route } from 'react-router-dom';

import GoalsList from './goals/GoalsList';
import GoalDetails from './goals/GoalDetails';

function GoalsPage(props) {
    const { match } = props;

    return (
        <Switch>
            <Route exact path={`${match.url}`} component={GoalsList} />
            <Route path={`${match.url}/:id`} component={GoalDetails} />
        </Switch>
    );
}

export default GoalsPage;



// WEBPACK FOOTER //
// ./src/components/pages/GoalsPage.js